export const SUBSCRIPTION_TERM = {
  ThirtyDays: 'ThirtyDays',
  OneYear: 'OneYear',
  MultiYear: 'MultiYear',
  Custom: 'Custom',
};

const SUBSCRIPTION_TERM_MAPPING = [
  { value: SUBSCRIPTION_TERM.ThirtyDays, label: '30 Days' },
  { value: SUBSCRIPTION_TERM.OneYear, label: '1 Year' },
  { value: SUBSCRIPTION_TERM.MultiYear, label: 'Multi Year' },
  { value: SUBSCRIPTION_TERM.Custom, label: 'Custom' },
];

export const getSubscriptionTermLabel = value =>
  SUBSCRIPTION_TERM_MAPPING.find(item => item.value === value)?.label || 'Not set';

export const getSubscriptionTermOptions = () =>
  SUBSCRIPTION_TERM_MAPPING.map(({ value, label }) => ({ value, label }));
